module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-right-circle-2a66fcc9.svg";